import { EventsService } from '@nx-smartmonkey/shared/services';
import { mixPanel } from './Mixpanel';

export const eventsService = new EventsService([mixPanel]);
